import { call, put, takeEvery } from 'redux-saga/effects';
import { changeLeadOMConfig } from '../../requests/change_leadom_config_request';
import { changeLeadOMConfigRequestSuccess, changeLeadOMConfigRequestFailure } from '../actions/change_leadom_config.actions';
import { CHANGE_LEADOM_CONFIG_REQUEST } from '../constants/leadom_config.constants';
import { message_error, message_success } from '../../../../../components/Message';

function* changeLeadOMRequest({ _id, config }) {
    const { result, options } = yield call(changeLeadOMConfig, _id, config);
    if (result) {
        yield put(changeLeadOMConfigRequestSuccess(options));
        message_success('Changes saved successfully!');
    } else {
        yield put(changeLeadOMConfigRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changeLeadOMSaga() {
    yield takeEvery(CHANGE_LEADOM_CONFIG_REQUEST, changeLeadOMRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/redux/sagas/change_leadomatic_config.saga.js